(function() {
    'use strict';

    angular.module('app').filter('dayName', dayName);

    var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    function dayName() {
        return function (dayNumber) {
            return dayNames[dayNumber];
        }
    }
})();
